<template>
  <div>
    <l-editor
      disabled
      :isUploadImg="false"
      v-if="data.type == 'texteditor'"
      :height="data.height"
      v-model="data.default"
      :placeholder="data.placeholder"
    >
    </l-editor>
    <component
      v-else
      :is="getComponent(data.type)"
      v-model="data.default"
      v-bind="$deepClone(data)"
      :placeholder="data.placeholder"
      :options="myOptions"
      :isNotUpLoad="true"
      :showFileList="uploadFileList"
    >
      <span v-if="data.html" v-html="data.html" />
      <template v-if="['input'].includes(data.type) && data.prepend" #prepend>
        {{ data.prepend }}
      </template>
      <template v-if="['input'].includes(data.type) && data.append" #append>
        {{ data.append }}
      </template>
    </component>
  </div>
</template>
<script>
import mixin from "../../mixin";
export default {
  name: "drag-form-item",
  mixins: [mixin()],
  inject: ["formDesign"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    uploadFileList() {
      if (this.data.subfield) {
        return "popover";
      } else {
        return true;
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    toValueType(type, value) {
      if (!this.$validatenull(value) && !this.$validatenull(type)) {
        switch (type) {
          case "boolean":
            return value == "true";
          case "string":
            return value;
          case "number":
            return Number(value);
        }
      }
    },
  },
};
</script>